import { useApi } from '@/api';
import { ChartSkeleton, ChartTimeFilter } from '@/components';
import HistoricGraphs from './HistoricGraphs';
import { useMemo, useState } from 'react';
import { Flex } from '@blockanalitica/ui';

export default function HistoricTabs() {
  const [chartDaysAgo, setChartDaysAgo] = useState('30');
  const [data, error] = useApi({
    url: `/base/psm3/historic/`,
    queryParams: {
      days_ago: chartDaysAgo
    }
  });

  const timeFilter = useMemo(
    () => (
      <ChartTimeFilter activeOption={chartDaysAgo} onChange={setChartDaysAgo} />
    ),
    [chartDaysAgo]
  );

  if (error) {
    throw error;
  }

  let content;
  if (data) {
    content = (
      <HistoricGraphs
        data={data}
        timeFilter={timeFilter}
        chartDaysAgo={chartDaysAgo}
      />
    );
  } else {
    content = <ChartSkeleton />;
  }

  return (
    <Flex flexDirection="column" gap="xs">
      {content}
    </Flex>
  );
}
